import { useTr } from '../../context/langContext';
import { webStrings } from '../../i18n/web-strings';

/** Route-level loading state (lazy page chunk). */
export default function PageLoader() {
    const tr = useTr();
    return (
        <div className="flex animate-fade-in flex-col items-center justify-center py-24">
            <span className="h-10 w-10 animate-spin rounded-full border-[3px] border-line border-t-owner dark:border-t-owner-ink" />
            <p className="mt-4 text-sm font-medium text-ink2">{tr(webStrings, 'loading')}</p>
        </div>
    );
}
